import { Loading03Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { VerificationStatus } from "shared/types";
import { CombinedIncome } from "../types/income";
import { ReverifyRequest, ReverifyStatus } from "../types/reverify";
import { Card } from "shared/components/Card";
import { getReverifyDetails, getVerificationProcessingStatus } from "../utils";

const VARIANTS: Record<ReverifyStatus, { title: string }> = {
  [ReverifyStatus.ApplicantRequest]: {
    title: "Re-verification request was sent to the applicant"
  },
  [ReverifyStatus.DocumentsUpload]: {
    title: "Re-verifying income source"
  },
  [ReverifyStatus.Canceled]: {
    title: "Re-verification cancelled"
  },
  [ReverifyStatus.InitialVerification]: {
    title: "Verifying income source with documents..."
  }
};

const WARNING_STATUSES: ReverifyStatus[] = [
  ReverifyStatus.ApplicantRequest,
  ReverifyStatus.DocumentsUpload
];

interface Props {
  incomes: CombinedIncome[];
  reverifyRequests?: ReverifyRequest[];
  verificationStatus?: VerificationStatus;
}

export const ReverificationWarning = ({
  incomes,
  reverifyRequests = [],
  verificationStatus
}: Props) => {
  const reverifyingIncome = incomes.find((income) =>
    WARNING_STATUSES.includes(
      getVerificationProcessingStatus(
        income,
        reverifyRequests,
        verificationStatus
      )
    )
  );

  if (!reverifyingIncome) return null;

  const { reverificationType, initiatedBy, formattedDate, incomeName } =
    getReverifyDetails(reverifyingIncome, reverifyRequests, verificationStatus);
  const { title } = VARIANTS[reverificationType];

  return (
    <Card className="w-full py-4 px-2 mt-4 mb-3 space-y-1">
      <div className="flex items-center gap-3">
        <HugeiconsIcon
          icon={Loading03Icon}
          className="text-warning-600"
          size={20}
        />
        <p className="font-bold text-md text-content-1000">{title}</p>
      </div>
      <p className="font-medium text-sm text-content-500 pl-8">
        Re-verification was initiated by {initiatedBy} on {formattedDate}
        <br />
        Income source: {incomeName}
      </p>
    </Card>
  );
};
